import React from 'react';
import AutoSuggestionSelectComponent from '../../../common/auto-suggestion-select/Select';

export const AccountForFilter = ({
  AccountNames: options,
  ActiveAccountName: selectedValue,
  AccountChangeHandler: onChange,
}) => {
  return (
    <AutoSuggestionSelectComponent
      options={options}
      components={{ IndicatorSeparator: () => null }}
      inputClassName="coverage-for-filter height-32"
      value={selectedValue}
      onChange={onChange}
      isSearchable={false}
    />
  );
};
